import { createReducer } from '@reduxjs/toolkit'
import { AssignItem, AssignProject } from '../models/Review'
import {
  assignItem,
  setAssignedItems,
  setAssignedProjects,
  setEngineerOrganization,
  setSelectedProject,
  updateAssignedProject,
} from '../actions/review'
import { fetchEngineerOrganizationAsync } from '../services/reviewService'
import { Organization } from '../models/Organization'

const initialState: ReviewState = {
  assignedItems: [],
  assignedProjects: [],
  selectedProject: null,
  isLoadingEngineerOrganization: false,
}

interface ReviewState {
  assignedItems: AssignItem[]
  assignedProjects: AssignProject[]
  selectedProject: AssignProject | null
  isLoadingEngineerOrganization: boolean
  engineerOrganization?: Organization
}

const reviewReducer = createReducer(initialState, (builder) => {
  builder.addCase(setAssignedItems, (state, action) => {
    state.assignedItems = action.payload
  })
  builder.addCase(setAssignedProjects, (state, action) => {
    state.assignedProjects = action.payload
  })
  builder.addCase(assignItem, (state, action) => {
    state.assignedItems.push(action.payload)
  })
  builder.addCase(updateAssignedProject, (state, action) => {
    const projectIndex = state.assignedProjects.findIndex(
      (assignedProject) => assignedProject.file_id === action.payload.file_id,
    )
    if (projectIndex === -1) {
      return
    }

    const discilineIndex = state.assignedProjects[
      projectIndex
    ].disciplines.findIndex(
      (assignedDiscipline) => assignedDiscipline.id === action.payload.id,
    )
    if (discilineIndex !== -1) {
      state.assignedProjects[projectIndex].disciplines[discilineIndex] = {
        ...state.assignedProjects[projectIndex].disciplines[discilineIndex],
        ...action.payload,
      }
    }
  })
  builder.addCase(setSelectedProject, (state, action) => {
    const assignedProject = state.assignedProjects.find(
      (project) => project.id === action.payload,
    )
    state.selectedProject = assignedProject ?? null
  })
  builder.addCase(fetchEngineerOrganizationAsync.pending, (state, action) => {
    state.isLoadingEngineerOrganization = true
  })
  builder.addCase(fetchEngineerOrganizationAsync.fulfilled, (state, action) => {
    state.isLoadingEngineerOrganization = false
  })
  builder.addCase(setEngineerOrganization, (state, action) => {
    state.engineerOrganization = action.payload
  })
})

export default reviewReducer
